"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _material = require("@mui/material");

require("./ToggleSwitch.styles.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/*
*
* ToggleSwitch
*
*/
function ToggleSwitch(_ref) {
  var label = _ref.label,
      toggled = _ref.toggled,
      disabled = _ref.disabled,
      onToggle = _ref.onToggle;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "ToggleSwitch_container"
  }, label && /*#__PURE__*/_react["default"].createElement("div", null, label), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_material.Switch, {
    checked: toggled,
    onChange: function onChange(e, checked) {
      return onToggle(checked);
    },
    disabled: disabled,
    style: {
      height: '24px'
    },
    disableRipple: true
  })));
}

ToggleSwitch.propTypes = {
  disabled: _propTypes["default"].bool,
  label: _propTypes["default"].node,
  toggled: _propTypes["default"].bool.isRequired,
  onToggle: _propTypes["default"].func.isRequired
};
var _default = ToggleSwitch;
exports["default"] = _default;